import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { sdClient } from 'contexts/SDKClientContext';
import { useDebounceCallback } from 'custom_hooks/useDebounceCallback';
import { IndustriesTableCellProps } from 'pages/Settings/Industries/IndustriesTable';
import { errorMessage, industryNameMaxLength } from 'pages/Settings/Industries/shared';
import { updateIndustry } from 'utils/industries';
import { Filter } from 'utils/query_v3';

export function IndustryNameCell({ rowData, onChange }: IndustriesTableCellProps) {
    const debouncedValidate = useDebounceCallback(200, (value) => validate(value));

    const onSave = async (newValue: string | undefined) => {
        if (!newValue) {
            throw new Error('Missing industry name.');
        }
        try {
            await updateIndustry(rowData, { Name: newValue });
            onChange();
        } catch {
            return 'Unable to save Industry name';
        }
        return undefined;
    };

    const validate = async (val: string | undefined) => {
        if (!val || val.trim() === '') {
            return 'Industry name is required';
        }

        if (val.length > industryNameMaxLength) {
            return errorMessage;
        }

        const industryNameFiltered = await sdClient.getIndustries({
            filter: Filter.eq('Name', val),
        });

        if (industryNameFiltered.Result.some(({ Id }) => Id !== rowData.Id)) {
            return 'Industry already exists. Please enter a unique name.';
        }

        return undefined;
    };

    return (
        <TextInlineEditor
            onConfirm={onSave}
            value={rowData.Name}
            validate={async (value) => debouncedValidate(value)}
        />
    );
}
